import CategoryWrapper from "./CategoryWrapper";

export default CategoryWrapper;
